import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ThemeProvider } from "@mui/material/styles";
import { AlertsProvider, theme } from "@sista/dista-ui";
import { LanguageProvider, LoginFailureCheck, SistaUiWrapper, } from "@sista/fe-commons";
import { IdmClientContextProvider } from "@sista/idm-client";
import i18next from "i18next";
import React from "react";
import { CssBaseline, GlobalStyles } from "@mui/material";
import { BrowserRouter } from "react-router-dom";
import { UiContextProvider } from "@sista/library-stasi";
import { Content } from "./components/Content/Content";
const globalStyles = (_jsx(GlobalStyles, { styles: ".height-fullscreen { height: calc(100vh - 78px)} " +
        ".inline-chip { display: inline-block; margin-right: 4px } " +
        ".row-disabled { opacity: 0.5 }" }));
const App = ({ account }) => {
    return (_jsxs(ThemeProvider, { theme: theme, children: [_jsx(CssBaseline, {}), globalStyles, _jsx(AlertsProvider, { children: _jsx(IdmClientContextProvider, { clientId: process.env.REACT_APP_CLIENT_ID || "demo", loggedAccount: account, idmRoot: process.env.REACT_APP_IDM_ROOT || "/idm", ucetRoot: process.env.REACT_APP_UCET_ROOT || "/ucet", children: _jsx(LanguageProvider, { children: _jsx(React.Fragment, { children: _jsx(SistaUiWrapper, { children: _jsx(BrowserRouter, { basename: process.env.REACT_APP_BASEPATH, children: _jsxs(UiContextProvider, { children: [_jsx(LoginFailureCheck, {}), _jsx(Content, {})] }) }, i18next.language) }) }, i18next.language) }) }) })] }));
};
export default App;
